import { getAuditDetailsDataSource } from './audits-details.requests';
import { auditDetailsStore } from './audits-details.store';

export class AuditDetailsQuery {
  store = auditDetailsStore;

  auditDetails$ = getAuditDetailsDataSource.data$();


  get auditName() {
    return this.store.getValue().name;
  }

  get auditStatus() {
    return this.store.getValue().status;
  }

  get auditClientOrganisationUnit() {
    return this.store.getValue().clientOrganisationUnit;
  }

}

export const auditDetailsQuery = new AuditDetailsQuery();
